import React from 'react';
import PropTypes from 'prop-types';

export default class SavedSearchModal extends React.Component {
    constructor(props) {
        super(props);

        this.handleSaveClick = this.handleSaveClick.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);

        document.addEventListener('keydown', this.handleKeyDown);

        this.header = document.querySelector('header');
        if (this.header) {
            this.header.classList.add('u-display-none');
        }

        this.state = {
            name: props.name,
            newSearch: false,
        };
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);

        if (this.header) {
            this.header.classList.remove('u-display-none');
        }
    }

    handleNameChange(event) {
        this.setState({ name: event.target.value });
    }

    handleKeyDown(event) {
        if (event.keyCode === 27) {
            this.props.onCancelClick();
        }
    }

    handleSaveClick(event) {
        event.preventDefault();
        const name = !this.props.isExistingSavedSearch || this.state.newSearch ? this.state.name : undefined;
        this.props.onSaveClick(name);
    }

    handleNewSearchClick() {
        this.setState({ newSearch: true });
    }

    render() {
        return (
            <div className="modal modal--is-active" data-testid="save-search-modal" onClick={this.props.onCancelClick}>
                <div
                    className="modal__container"
                    tabIndex="-1"
                    role="dialog"
                    aria-modal="true"
                    aria-label={this.props.t('savedSearch.title')}
                    onClick={e => e.stopPropagation()}
                    style={{ outline: 'none' }}>
                    <div className="modal__header">
                        <div className="u-display-table">
                            <div className="u-display-cell u-text-center" role="presentation">
                                <h4 className="u-truncate u-ma0 u-t3">{this.props.t('savedSearch.title')}</h4>
                            </div>
                        </div>
                    </div>
                    <div className="modal__content">
                        {this.props.isLoggedIn ? (
                            <>
                                {this.props.isExistingSavedSearch && !this.state.newSearch ? (
                                    <div data-testid="save-search-modal-editing">
                                        {this.props.t('savedSearch.alreadySaved')}:
                                        <p>
                                            &laquo;
                                            <b>{this.props.name}</b>
                                            &raquo;
                                        </p>
                                        <div className="u-mt8">
                                            <button
                                                data-testid="save-search-modal-save-new"
                                                className="button button--default"
                                                onClick={this.handleNewSearchClick.bind(this)}>
                                                {this.props.t('savedSearch.saveAsNew')}
                                            </button>
                                        </div>
                                        {this.props.hasChanged && (
                                            <div className="u-mt8">
                                                <button
                                                    className="button button--cta"
                                                    data-testid="save-search-modal-save-changes"
                                                    onClick={this.handleSaveClick}>
                                                    {this.props.t('savedSearch.saveChanges')}
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <form name="saveSearch" data-testid="save-search-modal-form" onSubmit={this.handleSaveClick}>
                                        <div className="input input--text">
                                            <label htmlFor="name">{this.props.t('savedSearch.searchNameLabel')}</label>
                                            <input
                                                type="text"
                                                id="name"
                                                data-testid="save-search-modal-name"
                                                size="30"
                                                required
                                                autoFocus
                                                value={this.state.name}
                                                onChange={this.handleNameChange.bind(this)}
                                            />
                                        </div>
                                        <div className="u-mh0 u-mv16">
                                            <div className="input-toggle">
                                                <input
                                                    id="notify"
                                                    data-testid="save-search-modal-notifications"
                                                    type="checkbox"
                                                    checked={this.props.notifications}
                                                    onChange={this.props.onNotificationsToggle}
                                                />
                                                <label htmlFor="notify">{this.props.t('savedSearch.notify')}</label>
                                            </div>
                                        </div>
                                        <p className="u-mh0 u-d1">{this.props.t('savedSearch.notifyInfo')}</p>
                                    </form>
                                )}
                            </>
                        ) : (
                            <div data-testid="save-search-modal-log-in">
                                <div className="u-display-table u-mt8">
                                    <div className="u-display-cell u-text-right u-pr16">
                                        <a href="/loginForm.html">{this.props.t('common:action.login')}</a>
                                    </div>
                                    <div className="u-display-cell u-pl16">
                                        <a href="/loginForm.html">{this.props.t('common:action.newUser')}</a>
                                    </div>
                                </div>
                                <p className="u-mh0 u-text-center">{this.props.t('savedSearch.loginToSave')}</p>
                            </div>
                        )}
                    </div>
                    <div className="modal__footer">
                        <div className="u-display-table">
                            <div className="u-display-cell u-text-left">
                                <button
                                    className="button button--flat"
                                    data-testid="save-search-modal-cancel"
                                    onClick={this.props.onCancelClick}>
                                    {this.props.t('common:action.cancel')}
                                </button>
                            </div>
                            {this.props.isLoggedIn && (!this.props.isExistingSavedSearch || this.state.newSearch) && (
                                <div className="u-display-cell u-text-right">
                                    <button
                                        className="button button--cta"
                                        data-testid="save-search-modal-save"
                                        onClick={this.handleSaveClick}>
                                        {this.props.t('common:action.save')}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

SavedSearchModal.propTypes = {
    name: PropTypes.string.isRequired,
    notifications: PropTypes.bool.isRequired,
    isExistingSavedSearch: PropTypes.bool.isRequired,
    hasChanged: PropTypes.bool.isRequired,
    onCancelClick: PropTypes.func.isRequired,
    onSaveClick: PropTypes.func.isRequired,
    onNotificationsToggle: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
};
